import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;
let baseUrl2 = `${httpUrl.host}/gy-apartment`;

let api = {
  //物业费——分页
  getNicePropertyFeePage: `${baseUrl}/nice/financePropertyLedger/getPage`,

  //物业费——导出
  exportPropertyFee: `${baseUrl}/nice/financePropertyLedger/export`,

  //物业费——生成账单
  generatePropertyFeeBill: `${baseUrl}/nice/financePropertyLedger/generateBill`,

  //物业费——确认操作
  confirmPropertyFeeBill: `${baseUrl}/nice/financePropertyLedger/confirm`,

  //物业费——取消操作
  cancelPropertyFeeBill: `${baseUrl}/nice/financePropertyLedger/cancel`,

  //用电配额——分页
  getNiceElectricityQuotaPage: `${baseUrl}/nice/financeElectricityQuota/getPage`,

  //用电配额——导入
  importElectricityQuota: `${baseUrl}/nice/financeElectricityQuota/import`,

  //用电配额——详情
  getElectricityQuotaByCode: `${baseUrl}/nice/financeElectricityQuota/getByCode`,

  //用电配额——修改
  updateElectricityQuota: `${baseUrl}/nice/financeElectricityQuota/update`,

  //用电配额——删除
  deleteElectricityQuota: `${baseUrl}/nice/financeElectricityQuota/deleteByCodes`,

  //用电配额——导入模板
  exportMbUrl: `https://damai-yq.oss-cn-hangzhou.aliyuncs.com/%E7%94%A8%E7%94%B5%E9%85%8D%E9%A2%9D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E4%B8%8B%E8%BD%BD.xlsx`,

  //物业代收费用——分页
  getPropertyFeePage: `${baseUrl}/nice/PropertyFee/getPage`,

  //物业代收费用——手动生成报表
  generateReport: `${baseUrl}/nice/PropertyFee/generateReport`,

  //物业代收费用——导出
  exportPropertyCost: `${baseUrl}/nice/PropertyFee/export`,

  //临时停车费用——分页
  getBillStatisticPage: `${baseUrl2}/billStatistic/getPage`,

  //临时停车费用——导出
  exportBillStatistic: `${baseUrl2}/billStatistic/export`,

  //分摊用电费用——分页
  getShareBillPage: `${baseUrl}/nice/share/bill/getPage`,

  //分摊用电费用——查询
  getUnusedBillConfig: `${baseUrl}/nice/share/config/getUnusedBillConfig`,

  //分摊用电费用——添加
  useBillConfig: `${baseUrl}/nice/share/bill/useBillConfig`,

  //发票用电量——分页
  getShareConfigPage: `${baseUrl}/nice/share/config/getPage`,

  //发票用电量——添加
  getUseBillConfig: `${baseUrl}/nice/share/config/add`,

  //物业费——下载导入模板
  exportNiceMould: `https://damai-yq.oss-cn-hangzhou.aliyuncs.com/纳爱斯补交物业费导入模板.xlsx`,

  //物业费——导入
  importFinancePropertyLedger: `${baseUrl}/nice/financePropertyLedger/import`,

  // 查询通知单模板
  getTemplateList: `${baseUrl}/template/getList`,

  //物业费催收单
  createPropertyLedgerUrl: `${baseUrl}/nice/financePropertyLedger/createPropertyLedgerUrl`,

  //物业费批量催收单
  createPatchPropertyLedgerUrl: `${baseUrl}/nice/financePropertyLedger/createPatchPropertyLedgerUrl`,

  //合同列表
  searchFinancePropertyLedgerContract: `${baseUrl}/nice/financePropertyLedger/searchContract`,

  //添加补交物业费信息
  addFinancePropertyLedgerFromContract: `${baseUrl}/nice/financePropertyLedger/addFromContract`,
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/PropertyFee.js